"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
function renderExpandIcon(locale) {
    return function expandIcon(_a) {
        var _b;
        var prefixCls = _a.prefixCls, onExpand = _a.onExpand, record = _a.record, expanded = _a.expanded, expandable = _a.expandable;
        var iconPrefix = "".concat(prefixCls, "-row-expand-icon");
        return (React.createElement("button", { type: "button", onClick: function (e) {
                onExpand(record, e);
                e.stopPropagation();
            }, className: (0, classnames_1.default)(iconPrefix, (_b = {},
                _b["".concat(iconPrefix, "-spaced")] = !expandable,
                _b["".concat(iconPrefix, "-expanded")] = expandable && expanded,
                _b["".concat(iconPrefix, "-collapsed")] = expandable && !expanded,
                _b)), "aria-label": expanded ? locale.collapse : locale.expand }));
    };
}
exports.default = renderExpandIcon;
//# sourceMappingURL=ExpandIcon.js.map